import {useAuth0} from "@auth0/auth0-react";
import {ActionButton} from "../../util/UI/ActionButton";

export const BookingFlowLogin = () => {

  const {loginWithPopup} = useAuth0();
  
  return <div style={{display: 'flex', flexDirection: "column", alignItems:'center', textAlign: 'start'}}>
    <b>Please log in to Kensu to complete your booking.</b>
    <ActionButton onClick={loginWithPopup}>Login</ActionButton>
  </div>
}